var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotHello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 146,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mascot-hello-text)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E32752",
    d: "M44.135 144.432c-2.05-.293-2.32-8.909-2.197-13.18l8.423 2.197c-1.22 3.783-4.175 11.276-6.226 10.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3160",
    d: "M82.225 144.798c-2.051.586-5.738-6.834-7.325-10.617l9.156-5.492c.244 5.126.22 15.523-1.831 16.109Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.836,
    cy: 97.57,
    fill: "#FFBD23",
    rx: 10.621,
    ry: 9.885
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.527,
    cy: 97.204,
    fill: "#E32752",
    rx: 13.185,
    ry: 19.038
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.621,
    cy: 9.885,
    fill: "#FFED8A",
    rx: 10.621,
    ry: 9.885,
    transform: "matrix(-1 0 0 1 117.75 87.685)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.959,
    cy: 9.885,
    fill: "#FFBD23",
    rx: 6.959,
    ry: 9.885,
    transform: "matrix(-1 0 0 1 115.553 87.685)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.185,
    cy: 19.038,
    fill: "#FF3160",
    rx: 13.185,
    ry: 19.038,
    transform: "matrix(-1 0 0 1 112.623 78.166)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 96.838,
    fill: "url(#mascot-hello)",
    rx: 43.583,
    ry: 42.835
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFED8A",
    fillRule: "evenodd",
    d: "M58.053 139.523c22.356-1.828 39.92-20.241 39.92-42.686 0-22.444-17.564-40.857-39.92-42.686a44.948 44.948 0 0 1 3.662-.149c24.07 0 43.583 19.178 43.583 42.835 0 23.658-19.513 42.835-43.583 42.835-1.233 0-2.455-.05-3.662-.149Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M37.53 61.198a43.763 43.763 0 0 1 1.594-.999c5.703 5.706 13.389 18.37 12.547 37.56a1.64 1.64 0 0 1-1.35 1.547c-3.49.611-9.088 1.303-15.146 1.484-5.66.169-11.777-.106-16.963-1.338a42.67 42.67 0 0 1-.074-1.903c5.053 1.28 11.2 1.583 16.982 1.41 5.873-.175 11.308-.839 14.728-1.43.788-18.963-6.995-31.18-12.319-36.33ZM105.283 97.974a42.948 42.948 0 0 0 .009-1.89c-5.114 1.308-11.849 1.943-18.224 2.112-6.478.173-12.497-.136-15.959-.674-.463-10.767 1.459-19.72 4.137-26.45 2.242-5.631 4.992-9.65 7.274-11.883a43.659 43.659 0 0 0-1.715-.87c-2.426 2.532-5.098 6.645-7.26 12.077-2.787 6.998-4.758 16.266-4.258 27.365a1.63 1.63 0 0 0 1.362 1.542c3.59.58 9.826.901 16.468.724 6.242-.166 12.922-.774 18.166-2.053Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.909,
    cy: 97.204,
    fill: "#000",
    rx: 8.057,
    ry: 19.038
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M45.215 105.243c.482-2.442.752-5.167.752-8.04 0-1.494-.073-2.95-.211-4.345-1.717-2.683-4.591-4.441-7.847-4.441-3.255 0-6.129 1.758-7.846 4.441a44.267 44.267 0 0 0-.21 4.345c0 2.873.268 5.598.75 8.04 1.747 2.247 4.372 3.676 7.306 3.676 2.935 0 5.56-1.429 7.306-3.676Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M45.504 103.579c.3-1.993.463-4.14.463-6.375 0-1.133-.042-2.243-.122-3.321a4.451 4.451 0 0 0-1.71-.34c-2.629 0-4.76 2.294-4.76 5.125s2.131 5.126 4.76 5.126c.476 0 .936-.075 1.37-.215Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.591,
    cy: 97.936,
    fill: "#000",
    rx: 8.057,
    ry: 18.306
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M89.974 105.278c.433-2.247.674-4.731.674-7.342a40.74 40.74 0 0 0-.253-4.568c-1.722-2.55-4.575-4.219-7.804-4.219-3.23 0-6.083 1.67-7.805 4.222a40.744 40.744 0 0 0-.253 4.565c0 2.61.24 5.093.674 7.34 1.746 2.223 4.406 3.643 7.384 3.643 2.978 0 5.636-1.419 7.383-3.641Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M90.261 103.554c.251-1.77.387-3.658.387-5.618 0-1.404-.07-2.772-.201-4.086a4.452 4.452 0 0 0-1.63-.307c-2.63 0-4.76 2.294-4.76 5.125s2.13 5.126 4.76 5.126c.504 0 .989-.084 1.444-.24Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.831,
    d: "M56.222 100.865c.366 2.563 5.493 5.493 7.69.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M63.18 70.844c-.879-.586-1.831.976-2.197 1.83-.244-1.098-1.172-3.002-2.93-1.83-2.198 1.464 1.831 5.491 2.93 5.125 1.098-.366 3.296-4.393 2.197-5.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6437C1",
    fillRule: "evenodd",
    d: "M-5.492 24.687a4.258 4.258 0 0 0-3.024 5.218l6.968 26.005a4.258 4.258 0 0 0 5.242 3.004l7.69-2.115-2.556 8.944 12.611-1.258L22.86 73l2.838-13.482-7.644.548 3.544-6.076 60.841-16.733a4.257 4.257 0 0 0 3.123-3.892l1.372-27.377c.144-2.88-2.554-5.066-5.34-4.33l-87.085 23.03Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m3.359 47.755 4.576-1.226.043-5.078 4.185-1.121-.044 5.077 4.576-1.226.145-14.166-4.576 1.226-.064 5.002-4.185 1.121.064-5.002-4.576 1.227-.144 14.166ZM19.155 43.522l11.773-3.154.028-3.883-7.274 1.95.027-1.542 6.688-1.792.027-3.418-6.688 1.792.014-1.437 7.176-1.922.048-3.888L19.3 29.356l-.145 14.166ZM33.29 39.734l10.815-2.897.047-4.05-6.239 1.672.098-10.117-4.576 1.226-.144 14.166ZM46.185 36.28l10.814-2.898.047-4.05-6.238 1.672.097-10.117-4.576 1.226-.144 14.166ZM66.103 31.225c4.595-1.231 7.077-5.812 5.983-9.898-.904-3.37-4.377-5.225-8.405-4.146-4.595 1.232-7.078 5.812-5.983 9.898.903 3.37 4.376 5.225 8.405 4.146Zm-.727-3.963c-1.643.44-2.815-.416-3.189-1.81-.444-1.657.304-3.794 2.22-4.308 1.643-.44 2.816.416 3.19 1.81.443 1.657-.304 3.795-2.22 4.308ZM75.627 23.99l2.23-.597 1.433-7.084.045-3.04-4.967 1.331-.044 3.04 1.303 6.35ZM74.44 28.71l4.537-1.216.03-3.64-4.537 1.215-.03 3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.621 46.751 4.576-1.226.044-5.077 4.184-1.122-.043 5.078 4.575-1.226.145-14.166-4.576 1.226-.064 5.002-4.185 1.121.064-5.002-4.575 1.226-.145 14.166ZM17.418 42.519l11.772-3.155.028-3.882-7.274 1.949.027-1.541 6.688-1.792.027-3.418-6.688 1.792.014-1.437 7.176-1.923.049-3.888-11.675 3.128-.144 14.167ZM31.553 38.731l10.814-2.898.047-4.048-6.238 1.67.097-10.116-4.576 1.226-.144 14.166ZM44.447 35.276l10.814-2.898.047-4.049-6.238 1.672.097-10.117-4.575 1.226-.145 14.166ZM64.365 30.222c4.595-1.232 7.078-5.812 5.983-9.898-.903-3.37-4.376-5.225-8.405-4.146-4.595 1.231-7.078 5.812-5.983 9.898.904 3.37 4.377 5.225 8.405 4.146Zm-.727-3.963c-1.642.44-2.815-.416-3.188-1.81-.444-1.657.303-3.795 2.22-4.308 1.642-.44 2.815.416 3.188 1.81.444 1.657-.303 3.794-2.22 4.308ZM73.89 22.987l2.228-.597 1.435-7.085.045-3.04-4.967 1.332-.045 3.04 1.303 6.35ZM72.7 27.705l4.537-1.215.03-3.641-4.536 1.215-.03 3.641Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mascot-hello",
    x1: 17.958,
    x2: 89.763,
    y1: 54.003,
    y2: 132.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FFDE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mascot-hello-text"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h127v145H.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotHello);
export default __webpack_public_path__ + "static/media/mascot-hello.0f5d6a48.svg";
export { ForwardRef as ReactComponent };